export default __webpack_public_path__ + "static/media/myToday-app.9da3490d.png";